import { InMemoryCache } from '@apollo/client';
import _ from 'lodash';

function sortEntries(entries) {
  return entries.sort((a, b) => {
    const entryA = a?.name?.toUpperCase();
    const entryB = b?.name?.toUpperCase();
    let comparison = 0;
    if (entryA > entryB) {
      comparison = 1;
    } else if (entryA < entryB) {
      comparison = -1;
    }
    return comparison;
  });
}

function merge(existing = { entries: [] }, incoming) {
  const { entries: newEntries } = incoming;
  const { entries: oldEntries } = existing;

  const uniqueEntries = _.uniqBy(
    [...newEntries, ...oldEntries],
    entry => entry.__ref || entry.uid
  );
  const entries = sortEntries(uniqueEntries);

  return {
    ...incoming,
    entries,
  };
}

export const cache = new InMemoryCache({
  dataIdFromObject: object => {
    const typename = object.__typename;

    const identifier = object.uid || object.id;
    const dataId = typename && identifier ? `${typename}:${identifier}` : null;
    return dataId || identifier || null;
  },
  typePolicies: {
    VoiceFeatures: {
      keyFields: ['locationUid'],
    },
    VoicePhoneNumber: {
      keyFields: ['uid'],
    },
    Query: {
      fields: {
        integrations: {
          keyArgs: ['search'],
          merge,
        },
        dataFeeds: {
          keyArgs: ['integrationUid'],
          merge,
        },
        locationMappings: {
          keyArgs: ['search', 'integrationUid'],
          merge,
        },
        integrationDetails(existingData) {
          return existingData;
        },
        location(existingData) {
          return existingData;
        },
        locationDataFeedMappings: {
          keyArgs: ['integrationUid', 'locationUid'],
          merge: true,
        },
        organization: {
          keyArgs: ['uid'],
          merge: true,
        },
      },
    },
  },
});
